import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core'
import moment from 'moment'
import _ from 'lodash'
import { SessionService } from '@exchange/services/.'
import { GridSize, GridWrapperComponent } from 'common-components'
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal'

@Component({
  selector: 'app-audit-detail',
  templateUrl: './audit-detail.component.html',
  styleUrls: ['./audit-detail.component.scss'],
  standalone: false
})
export class AuditDetailComponent implements OnInit {
  dateFormat = 'MM/DD/YYYY hh:mm A'

  @ViewChild('gridProcessingNotes', { static: true }) gridProcessingNotes: GridWrapperComponent
  @ViewChild('gridAuditInfo', { static: true }) gridAuditInfo: GridWrapperComponent
  @Output() closeClicked = new EventEmitter()

  GridSize = GridSize
  processingNotes: any[] = []
  auditInfo: any[] = []
  user = null
  modalRef: BsModalRef

  constructor(
    private session: SessionService,
    private modalService: BsModalService
  ) {}

  initializeProcessingNotesGrid() {
    this.gridProcessingNotes.hasPagination = false
    this.gridProcessingNotes.gridOptions.columnDefs = [
      {
        headerName: 'Date',
        field: 'Date',
        width: 150
      },
      {
        headerName: 'Notes',
        field: 'Notes',
        width: 500
      },
      {
        headerName: 'Username',
        field: 'Username',
        width: 200
      }
    ]
  }

  initializeAuditInfoGrid() {
    this.gridAuditInfo.hasPagination = false
    this.gridAuditInfo.gridOptions.columnDefs = [
      {
        headerName: 'Field',
        field: 'FieldName',
        width: 200
      },
      {
        headerName: 'Value From',
        field: 'OldValue',
        width: 200
      },
      {
        headerName: 'Value To',
        field: 'NewValue',
        width: 200
      },
      {
        headerName: 'Date',
        field: 'Date',
        width: 150
      },
      {
        headerName: 'Username',
        field: 'Username',
        width: 200
      }
    ]
  }

  ngOnInit() {
    this.initializeProcessingNotesGrid()
    this.initializeAuditInfoGrid()

    // TODO: (JRG) Get this data from the web service
    this.processingNotes = [
      {
        Date: moment().format('MM/DD/YYYY hh:mm A'),
        Notes: 'Added allowed amount based on updated guidelines from payer.',
        Username: 'Ben Ross'
      }
    ]

    this.gridProcessingNotes.data = _.cloneDeep(this.processingNotes)

    this.auditInfo = [
      {
        FieldName: 'Allowed Amount',
        OldValue: '',
        NewValue: '$100.00',
        Date: moment().format(this.dateFormat),
        Username: 'Ben Ross'
      }
    ]
    this.gridAuditInfo.data = _.cloneDeep(this.auditInfo)
    this.session.getCurrentUser().subscribe(user => (this.user = user))
  }

  saveAddEntry = (notes: string) => {
    this.processingNotes.push({
      Date: moment().format(this.dateFormat),
      Notes: notes,
      Username: this.user.FirstName + ' ' + this.user.LastName
    })

    this.gridProcessingNotes.data = _.cloneDeep(this.processingNotes)

    return this.modalRef.hide()
  }

  addEntry() {
    this.modalRef = this.modalService.show(AuditDetailAddEntryModalComponent, {
      initialState: { saveAddEntry: this.saveAddEntry }
    })
  }

  public Refresh() {
    // this will only work once we are using odata endpoints...
    // this.gridAuditInfo.getData();
    // this.gridProcessingNotes.getData();
  }
}

@Component({
  templateUrl: './audit-detail-add-entry-modal.component.html',
  standalone: false
})
export class AuditDetailAddEntryModalComponent {
  notes = ''

  saveAddEntry: (notes: string) => void
  constructor(public modalRef: BsModalRef) {}

  saveOnEnter($event) {
    if ($event.keyCode === 13) {
      return this.saveAddEntry(this.notes)
    }
  }
}
